export enum DropDownSelectEvents {
  viewIncidents = 'viewIncidents',
  viewEvents = 'viewEvents',
}
